import * as React from 'react';
import {Svg, Path} from 'react-native-svg';

const EmptyCards = props => {
  return (
    <Svg
      width={141}
      height={126}
      viewBox="0 0 141 126"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}>
      <Path
        d="M63.54 10.39s-5.292 27.26-35.718 28.337c-30.427 1.077-38.753 44.964-7.865 53.116 30.887 8.152 15.671 29.249 36.002 33.522 23.107 4.856 23.394-29.33 39.462-29.88 35.464-1.212 53.816-17.454 40.99-30.627C113.898 41.733 102.3 45.46 103.087 26.98c.788-18.48-32.527-38.86-39.547-16.59z"
        fill="#DEEFFF"
      />
      <Path
        d="M98.432 30.019L26.204 44.925a4.254 4.254 0 00-3.306 5.027L32.2 95.029a4.255 4.255 0 005.026 3.307l72.228-14.906a4.255 4.255 0 003.307-5.027l-9.303-45.077a4.255 4.255 0 00-5.027-3.307z"
        fill="#3D87BF"
      />
      <Path
        d="M96.312 35.431l-8.319 1.717a2.553 2.553 0 00-1.984 3.016l1.717 8.319a2.553 2.553 0 003.016 1.984l8.319-1.717a2.553 2.553 0 001.984-3.016l-1.717-8.319a2.553 2.553 0 00-3.016-1.984zM63.017 70.548L34.95 76.341a.17.17 0 00-.132.2l.85 4.115a.17.17 0 00.2.132l28.068-5.792a.17.17 0 00.132-.201l-.849-4.115a.17.17 0 00-.2-.132zM76.797 76.664l-40.075 8.27a.17.17 0 00-.132.201l.849 4.115a.17.17 0 00.201.132l40.076-8.27a.17.17 0 00.132-.201l-.85-4.115a.17.17 0 00-.2-.132z"
        fill="#fff"
      />
      <Path
        d="M111.722 95.125c6.693 0 12.119-5.426 12.119-12.12 0-6.692-5.426-12.118-12.119-12.118s-12.119 5.426-12.119 12.119 5.426 12.12 12.119 12.12z"
        fill="#4AA6E1"
        stroke="#fff"
        strokeWidth={2}
        strokeMiterlimit={10}
      />
      <Path
        d="M116.391 81.985h-3.451a.205.205 0 01-.188-.125.207.207 0 01-.015-.078v-3.45a1.016 1.016 0 00-2.03 0v3.45a.19.19 0 01-.016.078.197.197 0 01-.044.066.196.196 0 01-.143.06h-3.451a1.014 1.014 0 000 2.03h3.451a.204.204 0 01.203.202v3.451a1.013 1.013 0 001.015 1.015 1.015 1.015 0 001.015-1.015v-3.45a.204.204 0 01.203-.204h3.451a1.014 1.014 0 000-2.03z"
        fill="#fff"
      />
    </Svg>
  );
};

export default EmptyCards;
